import * as fragments from './fragments';

export const bundleGet = (id) => `
query bundleGet {
  products(query: "tag:bundle_id::${id}", first: 9) {
    edges {
      node {
        ${fragments.product}
      }
    }
  }
}
`;

export const cartCreate = `
mutation cartCreate($input: CartInput!) {
  cartCreate(input: $input) {
    cart {
      id
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartBuyerIdentityUpdate = `
mutation cartCreate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
  cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesAdd = `
mutation cartLinesAdd(
  $cartId: ID!,
  $lines: [CartLineInput!]!,
  $countryCode: CountryCode!
)
@inContext(country: $countryCode) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesRemove = `
mutation cartLinesRemove(
  $cartId: ID!,
  $lineIds: [ID!]!,
  $countryCode: CountryCode!
)
@inContext(country: $countryCode) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesUpdate = `
mutation cartLinesUpdate(
  $cartId: ID!,
  $lines: [CartLineUpdateInput!]!,
  $countryCode: CountryCode!
)
@inContext(country: $countryCode) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const collectionGet = `
query collectionGet($id: ID!, $first: Int!) {
  collection(id: $id) {
    products(first: $first) {
      edges {
        node {
          ${fragments.product}
        }
      }
    }
  }
}`;

export const productCardGet = `
query getProductById($id: ID!) {
  product(id: $id) {
    ${fragments.product}
  }
}`;

export const productGroupGet = `
  query getProductCardGroup($id: ID!) {
    product(id: $id) {
      id
      title
      handle
      variants(first: 1) {
        edges {
          node {
            id
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            title
            badge: metafield(
            namespace: "custom", key: "badge"
            ) {
              value
            }
            images: metafield(
            namespace: "custom", key: "images"
            ) {
              references(first: 10) {
                edges {
                  node {
                    ...VariantImage
                  }
                }
              }
            }
            swatch: metafield(
            namespace: "custom", key: "swatch"
            ) {
              reference {
                ...Swatch
              }
            }
          }
        }
      }
      productGroup: metafield(namespace: "custom", key: "product_group") {
        reference {
          ... on Metaobject {
            name: field(key: "name") {
              value
            }
            products: field(key: "products") {
              references(first: 6) {
                edges {
                  node {
                    ... on Product {
                      title
                      handle
                      id
                      variants(first: 1) {
                        edges {
                          node {
                            id
                            price {
                              amount
                              currencyCode
                            }
                            compareAtPrice {
                              amount
                              currencyCode
                            }
                            title
                            badge: metafield(
                            namespace: "custom", key: "badge"
                            ) {
                              value
                            }
                            images: metafield(
                            namespace: "custom", key: "images"
                            ) {
                              references(first: 10) {
                                edges {
                                  node {
                                    ...VariantImage
                                  }
                                }
                              }
                            }
                            swatch: metafield(
                            namespace: "custom", key: "swatch"
                            ) {
                              reference {
                                ...Swatch
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            products2: field(key: "products_2") {
              references(first: 6) {
                edges {
                  node {
                    ... on Product {
                      title
                      handle
                      id
                      variants(first: 1) {
                        edges {
                          node {
                            id
                            price {
                              amount
                              currencyCode
                            }
                            compareAtPrice {
                              amount
                              currencyCode
                            }
                            title
                            badge: metafield(
                            namespace: "custom", key: "badge"
                            ) {
                              value
                            }
                            images: metafield(
                            namespace: "custom", key: "images"
                            ) {
                              references(first: 10) {
                                edges {
                                  node {
                                    ...VariantImage
                                  }
                                }
                              }
                            }
                            swatch: metafield(
                            namespace: "custom", key: "swatch"
                            ) {
                              reference {
                                ...Swatch
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment VariantImage on MediaImage {
    image {
      alt: altText
      desktopSrc: url(
        transform: {maxWidth: 300, scale: 2, preferredContentType: WEBP}
      )
    }
  }

  fragment Swatch on Metaobject {
    label: field(key: "label") {
      value
    }
    image: field(key: "image") {
      reference {
        ... on MediaImage {
          image {
            alt: altText
            src: url(transform: {preferredContentType: WEBP})
          }
        }
      }
    }
  }
`;

export const variantGet = `
query GetProductVariant($id: ID!) {
  node(id: $id) {
    ... on ProductVariant {
      ${fragments.variant}
      product {
        title
        handle
        description
        ignoreSafetyStock: metafield(
          namespace: "custom", key: "ignore_safety_stock"
        ){
          value
        }
        preventPurchaseWithOtherItems: metafield(
          namespace: "custom", key: "prevent_purchase_with_other_items"){
            value
          }
      }
    }
  }
}`;

export const cartAttributesUpdate = `
mutation cartAttributesUpdate($cartId: ID!, $attributes: [AttributeInput!]!) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const variantsMediaById = `
query variantsById($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on ProductVariant {
      description: metafield(namespace: "custom", key: "images"){
        references(first: 15){
          edges {
            node {
              ... on MediaImage {
                image {
                  alt: altText
                  height
                  id
                  src: url(transform: { preferredContentType: WEBP })
                  width
                }
                mediaContentType
              }
              ... on Video {
                sources {
                  url
                  format
                }
                mediaContentType
                previewImage {
                  alt: altText
                  height
                  id
                  src: url(transform: {preferredContentType: WEBP})
                  width
                }
              }
            }
          }
        }      
      }
    }
  }
}
`;
